export const importFromCsv = {
  importSuccessfully: 'Import uniforms successfully!',
  importFailed: 'Import uniforms failed!',
}
